import { render, staticRenderFns } from "./WishlistContainer.vue?vue&type=template&id=d86f85dc&scoped=true&"
import script from "./WishlistContainer.vue?vue&type=script&lang=js&"
export * from "./WishlistContainer.vue?vue&type=script&lang=js&"
import style0 from "./WishlistContainer.vue?vue&type=style&index=0&id=d86f85dc&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "d86f85dc",
  null
  
)

export default component.exports